type Listener = () => void;

const listeners = new Set<Listener>();

/**
 * Portal veya kategori değiştiğinde haber verilir. Kabuktaki mega menü kendi kopyasını
 * mount'ta bir kez çekiyor; bu olmadan değişiklik ancak sayfa yenilendiğinde görünüyordu.
 */
export function subscribePortalData(listener: Listener): () => void {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}

export function notifyPortalDataChanged(): void {
  listeners.forEach((listener) => listener());
}
